<section appScrollAnimation>
  <div id="market-insights">
    <div class="container">
      <div class="market-insights-wrapper">
        <div class="left-content-wrapper">
          <p class="labels font-16">{{"coming" | translate}}</p>
          <h2 class="heading">{{"market" | translate}}</h2>
          <div class="market-para-content">
            <p class="para1">{{"market-para" | translate}}</p>
          </div>
        </div>
        <div class="img-wrapper">
          <img src="assets/images/market_insights.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</section>